import React from 'react';
import i18n from 'i18next';
import { PhoneInput, Input, Form, FieldErrors } from '@weezevent/nacre';

export default function Phone({ value = null, field = null, onChange = () => {}, className = null, disabled = false, countryCodeEditable = false, errors = false }) {
    const locale = i18n.language;

    const country = React.useMemo(() => {
        const language_splitted = locale.split('-');
        return language_splitted.length === 2 ? language_splitted[1].toLowerCase() : language_splitted[0].toLowerCase();
    }, [locale]);

    const withDialCode = React.useMemo(() => {
        const dialCodeRegex = /^[(]?[+][0-9]{1,4}[)]?.*/gm;
        if (value) {
            return dialCodeRegex.test(value.trim());
        }
        return true;
    }, [value]);

    return withDialCode ? (
        <PhoneInput
            className={className}
            useNew
            country={country}
            {...field}
            value={value}
            onChange={(value, infos, event, valueFormatted) => onChange(valueFormatted)}
            disabled={disabled}
            countryCodeEditable={countryCodeEditable}
            errors={errors ? [errors] : []}
        />
    ) : (
        <Input className={className} errors={errors && [errors]} disabled={disabled} {...field} value={value} onChange={({ target: { value } }) => onChange(value)} />
    );
}

export function PhoneLabel({ onChange = () => {}, label = null, ...rest }) {
    const { errors } = { ...rest };
    return (
        <Form.Field>
            {label && <Form.Label label={label} />}
            <Phone onChange={onChange} {...rest} errors={errors} />
            <FieldErrors errors={errors && [errors]} />
        </Form.Field>
    );
}
